/** Shared user pool (web client). */
const USER_POOL_ID = "us-east-1_7gcab3pm0";

/** Web / browser OAuth client. */
const WEB_USER_POOL_CLIENT_ID = "5govt33qtdt6597okel7hcm6nq";

const OAUTH_DOMAIN = "auth.puzzleinteract.com";
const OAUTH_SCOPES = ["openid", "profile", "email"];

const webOAuth = {
    domain: OAUTH_DOMAIN,
    scopes: OAUTH_SCOPES,
    responseType: "code",
    redirectSignIn: [
        "http://localhost:3000/login",
        "http://localhost:3000",
        "http://localhost",
        "https://localhost",
        "https://dev.puzzleinteract.com/login",
        "https://dev.puzzleinteract.com",
        "https://game.puzzleinteract.com/login",
        "https://game.puzzleinteract.com",
        "https://www.puzzleinteract.com/login",
        "https://www.puzzleinteract.com",
    ],
    redirectSignOut: [
        "http://localhost:3000",
        "http://localhost",
        "https://localhost",
        "https://dev.puzzleinteract.com",
        "https://game.puzzleinteract.com",
        "https://www.puzzleinteract.com",
    ],
};

function buildConfig(userPoolClientId, oauth) {
    return {
        Auth: {
            Cognito: {
                userPoolId: USER_POOL_ID,
                userPoolClientId,
                signUpVerificationMethod: "code",
                loginWith: {
                    oauth,
                },
            },
        },
    };
}

/** Amplify Auth config for web browser. */
export const getCognitoConfig = () => buildConfig(WEB_USER_POOL_CLIENT_ID, webOAuth);
